class PlaidError extends Error {
  constructor (msg: string) {
    super(msg)
    Object.setPrototypeOf(this, PlaidError.prototype)
  }
}

class VGSError extends Error {
  constructor (msg: string) {
    super(msg)
    Object.setPrototypeOf(this, VGSError.prototype)
  }
}

class GranularAllowancesError extends Error {
  constructor (msg: string) {
    super(msg)
    Object.setPrototypeOf(this, GranularAllowancesError.prototype)
  }
}

class StripeElementsError extends Error {
  constructor (msg: string) {
    super(msg)
    Object.setPrototypeOf(this, StripeElementsError.prototype)
  }
}

export { GranularAllowancesError, PlaidError, StripeElementsError, VGSError }
